import { render } from "./ProdukDetail.vue?vue&type=template&id=27cfd4d4"
import script from "./ProdukDetail.vue?vue&type=script&lang=js"
export * from "./ProdukDetail.vue?vue&type=script&lang=js"

import "./ProdukDetail.vue?vue&type=style&index=0&id=27cfd4d4&lang=css"
script.render = render

export default script